module.exports = __webpack_public_path__ + "static/media/apy.4a09f317.svg";